import axios from "axios";
import config from "config/config";
import { T_Stats } from "types";

export async function getStats(userId: string) {
  const res = await axios.get(`${config.apiUrl}/email/get-stats/${userId}`);
  const stats = res.data;
  return stats as T_Stats;
}
